import { createSelector } from 'reselect';
import _get from 'lodash/get';
import _forEach from 'lodash/forEach';

const selectIrisData = (state) => _get(state, 'irisData');

/**
 *  to search componentName from irisData.
 *  @param {string} componentName
 *  @param {object} irisData
 */
export const irisDataProcessor = (irisData, componentName) => {
    if (!componentName) {
        // If not filter return immediately
        return irisData;
    }
    // Get all content row nodes and iterate
    const rows = _get(irisData, 'content.rows');
    let component = [];
    _forEach(rows, (rowsItem) => {
        // for each row iterate columns
        const cols = _get(rowsItem, 'columns');
        _forEach(cols, (colsItem) => {
            // for each cols iterate components
            const comps = _get(colsItem, 'components');
            _forEach(comps, (compsItem) => {
                const componentType = _get(compsItem, 'componentType');
                if (componentType === componentName) {
                    component = compsItem;
                    return false;
                }
                return true;
            });
        });
    });
    return _get(component, 'content');
};

const getIrisInteractiveVizNavInfo = (state, selfProps) => _get(selfProps, 'irisData', undefined);

/*
this selector is to select value from pros irisData example: when irisData is passed to component directly
in case its not passing directly then irisData will procees from stored irisData which is in row and coloumn
format.

selectIrisData : will give irisData from state which is in row format . [row and column format]
*/

export const getInteractiveVizNavFromIrisDataState = createSelector(
    [selectIrisData, getIrisInteractiveVizNavInfo],
    (irisDataFromState, irisDataFromProps) => {
        if (irisDataFromProps) {
            return irisDataFromProps;
        }
        if (irisDataFromState) {
            return irisDataProcessor(irisDataFromState, 'interactivevisnav');
        }
        return null;
    }
);

export const getInteractiveVizNav = createSelector(
    [getInteractiveVizNavFromIrisDataState],
    (irisInteractiveVizNavInfo) => {
        return irisInteractiveVizNavInfo && irisInteractiveVizNavInfo.navigations
            ? { interactiveVizNav: irisInteractiveVizNavInfo.navigations }
            : { interactiveVizNav: [] };
    }
);
